import React, { ReactElement } from 'react';

import { user, ErrorPage } from '../';
import { UserPermission } from '../types';

interface Props {
  permission: UserPermission | UserPermission[];
  children: React.ReactNode;
}

const AppAuthenticated: React.FC<Props> = ({ permission, children }) => {
  if (permission === undefined) return children as ReactElement<any>;

  if (Array.isArray(permission)) {
    if (permission.some(p => user.permissions?.includes(p))) {
      return children as ReactElement<any>;
    }
  } else if (user.permissions?.includes(permission)) {
    return children as ReactElement<any>;
  }

  return <ErrorPage errorCode="403" />;
};

AppAuthenticated.defaultProps = {
  permission: undefined,
} as Partial<Props>;

export default AppAuthenticated;
